<template>
  <div>
    <vxe-grid
      ref="predictTable"
      auto-resize
      highlight-hover-row
      resizable
      show-footer
      size="mini"
      row-id="amzSkuCode"
      cell-class-name="align-top"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="305"
      :footer-method="() => footerData"
      :highlight-current-row="highlightCurrentRow"
      @cell-click="onCellClick"
    >
      <template v-slot:monthProfit="{ row }">
        <span v-if="row.monthProfit < 0" style="color: #F54E60;">
          {{ row.monthProfit }}
        </span>
        <span v-else style="color: #67C23A;">{{ row.monthProfit }}</span>
      </template>
      <template v-slot:monthProfitRatio="{ row }">
        <span v-if="row.monthProfitRatio < 0" style="color: #F54E60;">
          {{ row.monthProfitRatio }}%
        </span>
        <span v-else style="color: #67C23A;">{{ row.monthProfitRatio }}%</span>
      </template>
      <template v-slot:addUpProfit="{ row }">
        <span v-if="row.addUpProfit < 0" style="color: #F54E60;">
          {{ row.addUpProfit }}
        </span>
        <span v-else style="color: #67C23A;">{{ row.addUpProfit }}</span>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import { format, add } from '@/libs/util.number.js'
import tableColumns from './table-columns'
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tablePage: { type: Object, default: () => {} },
    disabled: { type: Boolean, default: false },
    amzFirstDemandCode: { typ: String, default: '' },
    highlightCurrentRow: { typ: Boolean, default: false },
  },
  data() {
    return {
      format: (number) => format(number),
      tableColumns: tableColumns(this),
      tableData: [],
      loading: false,
      predictMonth: 1,
    }
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .map((c) => c.field)

      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .map((t) => {
          if (t.field == 'saleQty') {
            const val = totalColumnValues[t.field]
            return val ? format(val) : '0'
          } else {
            return ''
          }
        })
      result[0] = this.$l('table_label_total') || '合计'
      return [result]
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzFirstDemandCode) return
      this.loading = true
      const res = await this.$api
        .ecomAmzFirstDemandPredictListApi({
          amzFirstDemandCode: this.amzFirstDemandCode,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.tableData = res.body.data
      setTimeout(() => {
        // 设置选中行
        this.$refs.predictTable.setCurrentRow(
          this.tableData[this.predictMonth - 1]
        )
      }, 0)
      await this.initCurrentRow({ row: this.tableData[this.predictMonth - 1] })
    },
    onCellClick({ row }) {
      const tmpData = { ...row, preMonthProfit: 0 }
      this.predictMonth = row.predictMonth || 1
      if (this.predictMonth > 1) {
        tmpData.preMonthProfit =
          this.tableData[this.predictMonth - 2].addUpProfit || 0
      }
      this.$emit('onCellClick', tmpData)
    },
    async initCurrentRow({ row }) {
      const tmpData = { ...row, preMonthProfit: 0 }
      this.predictMonth = row.predictMonth || 1
      if (this.predictMonth > 1) {
        tmpData.preMonthProfit =
          this.tableData[this.predictMonth - 2].addUpProfit || 0
      }
      console.log(tmpData.preMonthProfit)
      this.$emit('initCurrentRow', tmpData)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
  .vxe-table--render-default .vxe-body--row:first-child .vxe-cell--valid {
    top: initial;
    padding-top: 4px;
  }
  .col-opt {
    padding-top: 0 !important;
  }
  .col--seq {
    padding-top: 11px !important;
  }
}
</style>
